function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo } from 'react';
import { ApolloProvider, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { UniversalAnalyticsContextProvider } from '@zillow/universal-analytics-react';
import PropertySearchWrapper from './components/PropertySearchWrapper';

var getApolloClient = function getApolloClient(gdpServiceUrl, serviceName) {
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      credentials: 'include',
      uri: gdpServiceUrl,
      headers: {
        'client-id': serviceName
      }
    })
  });
};

var HmimhwPropertySearch = function HmimhwPropertySearch(props) {
  var gdpServiceUrl = props.publicConfigValues.gdpServiceUrl,
      _props$serviceName = props.serviceName,
      serviceName = _props$serviceName === void 0 ? 'hmimhw-property-search' : _props$serviceName;
  var apolloClient = useMemo(function () {
    return getApolloClient(gdpServiceUrl, serviceName);
  }, [gdpServiceUrl, serviceName]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      requiredCustomDimensions = _useState2[0],
      setRequiredCustomDimensions = _useState2[1];

  return /*#__PURE__*/React.createElement(UniversalAnalyticsContextProvider, {
    options: {
      shouldRequireCustomDimensions: true
    },
    requiredCustomDimensions: requiredCustomDimensions || undefined
  }, /*#__PURE__*/React.createElement(ApolloProvider, {
    client: apolloClient
  }, /*#__PURE__*/React.createElement(PropertySearchWrapper, _extends({}, props, {
    setRequiredCustomDimensions: setRequiredCustomDimensions
  }))));
};

export default HmimhwPropertySearch;
//# sourceMappingURL=HmimhwPropertySearch.js.map